import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApiConnectivityService {
    private isConnectedSubject = new BehaviorSubject<boolean>(true);
    public isConnected$: Observable<boolean> = this.isConnectedSubject.asObservable();

    private consecutiveFailures = 0;
    private readonly FAILURE_THRESHOLD = 2; // Number of consecutive failures before showing warning

    constructor() {}

    /**
     * Report a successful API call
     */
    reportSuccess(): void {
        this.consecutiveFailures = 0;
        if (!this.isConnectedSubject.value) {
            this.isConnectedSubject.next(true);
        }
    }

    /**
     * Report a failed API call due to network/connection issues
     */
    reportFailure(): void {
        this.consecutiveFailures++;
        
        if (this.consecutiveFailures >= this.FAILURE_THRESHOLD && this.isConnectedSubject.value) {
            this.isConnectedSubject.next(false);
        }
    }

    /**
     * Get current connectivity status
     */
    isConnected(): boolean {
        return this.isConnectedSubject.value;
    }

    /**
     * Reset the connectivity state (can be used when user manually refreshes)
     */
    reset(): void {
        this.consecutiveFailures = 0;
        this.isConnectedSubject.next(true);
    }
}